import { useQuery } from "@tanstack/react-query";

import { getTenantReports } from "api/tenants";

import { queryKeys } from "./queryKeys";

import { PaginationTable } from "js/components/types";

interface UseGetTenantReportsOptions {
  pagination: PaginationTable;
  searchFilter?: string;
  additionalFilters?: {
    is_active?: string;
    status?: string;
    legal_type?: string;
  };
  enabled?: boolean;
}

export const useGetTenantReports = (options: UseGetTenantReportsOptions) => {
  const {
    pagination,
    searchFilter = "",
    additionalFilters = {},
    enabled = true,
  } = options;

  return useQuery({
    queryKey: queryKeys.tenantReports.list({
      pagination,
      filter: searchFilter,
      additionalFilters,
    }),
    queryFn: () => getTenantReports(pagination, searchFilter, additionalFilters),
    enabled,
    staleTime: 30 * 1000,
  });
};
